"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for Real controls
         */
        var Real = /** @class */ (function (_super) {
            __extends(Real, _super);
            function Real() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Real.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                this.$inputElement.addClass("real_input_edit");
                $dyn.observe(this.ThousandSeparator, this._updateThousandSeparator, this);
                $dyn.observe(this.CurrentSignDisplay, this._updateCurrentSignDisplay, this);
                $dyn.observe(this.DecimalSeparator, this._updateDecimalSeparator, this);
                $dyn.observe(this.NoOfDecimals, this._updateNoOfDecimals, this);
                $dyn.observe(this.MinNoOfDecimals, this._updateMinNoOfDecimals, this);
            };
            /**
             * The keyup event handler
             * @param evt The keyup event
             */
            Real.prototype.keyUp = function (evt) {
                if (evt && evt.which === $dyn.ui.KeyCodes.decimal && this.allowUserChanges() && this.UserFormat["."] !== ".") {
                    var evtTarget = evt.target;
                    var valueString = evtTarget.value;
                    if (valueString) {
                        // Find the lastIndexOf so we don't replace any other periods in the string (could be the thousand separator)
                        var decimalIndex = valueString.lastIndexOf(".");
                        if (decimalIndex > -1) {
                            var newValueString = valueString.substr(0, decimalIndex) + this.UserFormat["."] + valueString.substr(decimalIndex + 1);
                            // save off selectin start and end as IE can change them
                            var targetSelectionStart = $dyn.ui.selectionStart(evtTarget);
                            var targetSelectionEnd = $dyn.ui.selectionEnd(evtTarget);
                            evtTarget.value = newValueString;
                            // Changing the value loses the cursor position, so we need to restore it
                            $dyn.ui.selectionStart(evtTarget, targetSelectionStart);
                            $dyn.ui.selectionEnd(evtTarget, targetSelectionEnd);
                        }
                    }
                }
            };
            Real.prototype._regionalSettingsChanged = function () {
                _super.prototype._regionalSettingsChanged.call(this);
                this._updateThousandSeparator($dyn.value(this.ThousandSeparator));
                this._updateCurrentSignDisplay($dyn.value(this.CurrentSignDisplay));
                this._updateDecimalSeparator($dyn.value(this.DecimalSeparator));
                this._updateNoOfDecimals($dyn.value(this.NoOfDecimals));
                this._updateMinNoOfDecimals($dyn.value(this.MinNoOfDecimals));
            };
            /**
             * Update the number format the control uses when the thousand separator changes
             * @param value The new thousand separator value
             */
            Real.prototype._updateThousandSeparator = function (value) {
                var separator;
                switch (value) {
                    case $dyn.ui.ThousandSeparator.none:
                        separator = "";
                        break;
                    case $dyn.ui.ThousandSeparator.comma:
                        separator = ",";
                        break;
                    case $dyn.ui.ThousandSeparator.space:
                        separator = " ";
                        break;
                    case $dyn.ui.ThousandSeparator.apostrophe:
                        separator = "'";
                        break;
                    case $dyn.ui.ThousandSeparator.dot:
                        separator = ".";
                        break;
                    case $dyn.ui.ThousandSeparator.auto:
                    default:
                        separator = Globalize.culture().numberFormat[","];
                        // nbsp is charCode 160
                        if (separator === String.fromCharCode(160)) {
                            separator = " ";
                        }
                        break;
                }
                this.UserFormat[","] = separator;
                this.UserFormat.currency[","] = separator;
            };
            /**
             * Update the number format the control uses when the current sign display changes
             * @param value The new current sign display value
             */
            Real.prototype._updateCurrentSignDisplay = function (value) {
                // We only need to handle the currency pattern here, but we should not check IsMoney
                // first because that value may change after SignDisplay
                var signDisplay;
                switch (value) {
                    case $dyn.ui.SignDisplayType.None:
                        signDisplay = "$n";
                        break;
                    case $dyn.ui.SignDisplayType.Prefixed:
                        signDisplay = "-$n";
                        break;
                    case $dyn.ui.SignDisplayType.Suffixed:
                        signDisplay = "$n-";
                        break;
                    case $dyn.ui.SignDisplayType.Parentheses:
                        signDisplay = "($n)";
                        break;
                    case $dyn.ui.SignDisplayType.Auto:
                    default:
                        signDisplay = Globalize.culture().numberFormat.currency.pattern[0];
                        break;
                }
                this.UserFormat.currency.pattern = [signDisplay];
            };
            /**
             * Update the number format the control uses when the decimal separator changes
             * @param value The new decimal separator value
             */
            Real.prototype._updateDecimalSeparator = function (value) {
                var separator;
                switch (value) {
                    case $dyn.ui.DecimalSeparator.comma:
                        separator = ",";
                        break;
                    case $dyn.ui.DecimalSeparator.dot:
                        separator = ".";
                        break;
                    case $dyn.ui.DecimalSeparator.auto:
                    default:
                        separator = Globalize.culture().numberFormat["."];
                        break;
                }
                this.UserFormat["."] = separator;
                this.UserFormat.currency["."] = separator;
            };
            /**
             * Update the number format the control uses when the required number of decimals changes
             * @param value The new number of decimals value
             */
            Real.prototype._updateNoOfDecimals = function (value) {
                var decimals;
                switch (value) {
                    case $dyn.ui.autoValue:
                        decimals = Globalize.culture().numberFormat.decimals;
                        break;
                    default:
                        decimals = parseInt(value, 10);
                        break;
                }
                // update wire format and user format
                this.WireFormat.decimals = decimals;
                this.UserFormat.decimals = decimals;
                this.UserFormat.currency.decimals = decimals;
            };
            /**
             * Update the number format the control uses when deciding how many padding zeros to add
             * @param value The new number of MinNoOfdecimals value
             */
            Real.prototype._updateMinNoOfDecimals = function (value) {
                if (value !== $dyn.ui.autoValue) {
                    this.UserFormat.minDecimals = parseInt(value, 10);
                }
            };
            return Real;
        }(controls.Number));
        controls.Real = Real;
        Real.prototype.MaxValueNumber = "999999999999999.99";
        Real.prototype.MinValueNumber = "-999999999999999.99";
        Real.prototype.ThousandSeparator = $dyn.ui.ThousandSeparator.auto;
        Real.prototype.DecimalSeparator = $dyn.ui.DecimalSeparator.auto;
        Real.prototype.NoOfDecimals = $dyn.ui.autoValue;
        Real.prototype.AutoInsSeparator = $dyn.ui.autoValue;
        Real.prototype.MinNoOfDecimals = $dyn.ui.autoValue;
        Real.prototype.FormatMST = $dyn.ui.autoValue;
        // tslint:disable-next-line:no-string-literal
        Real.prototype["IgnoreDecimal"] = false;
        $dyn.adapter({ id: "Real", controlType: "Real", template: "Number" });
        $dyn.adapter({ id: "RealSummary", controlType: "Real", template: "SummaryField" });
        $dyn.adapter({ id: "RealLabel", controlType: "Real", template: "Label" });
        $dyn.adapter({ id: "RealCardCell", controlType: "Real", template: "CardCell" });
        var RealCell = /** @class */ (function (_super) {
            __extends(RealCell, _super);
            function RealCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            RealCell.prototype.updateValue = function () {
                return this._onChange();
            };
            RealCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            RealCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            RealCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            RealCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            RealCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            RealCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(RealCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return RealCell;
        }(Real));
        controls.RealCell = RealCell;
        $dyn.ui.addPropertiesToPrototype(RealCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "Real", template: "NumberCell" });
        $dyn.cellAdapter({ id: "Real", controlType: "RealCell", template: "NumberCellEditor", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Real.js.map
